export const ACCORDION_SECTIONS = {
  REGISTRATION_INFO: '0',
  PAYMENT_INFO: '1',
} as const;

export const VALIDATION_ERROR_MESSAGE_KEY =
  'domains.checkout.validation.required';

export const VALIDATION_ZIPCODE_INVALID_KEY =
  'domains.checkout.validation.zipCodeInvalid';

export const VALIDATION_PHONE_INVALID_KEY =
  'domains.checkout.validation.phoneInvalid';

export const REGISTRATION_FORM_FIELDS = [
  'firstName',
  'lastName',
  'ownerEmail',
  'country',
  'phone',
  'zipCode',
  'address',
  'state',
  'city',
] as const;
